import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { Loader2, UserPlus } from "lucide-react";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function MemberSignup() {
  const nav = useNavigate();
  const [form, setForm] = useState({ first_name:"", last_name:"", birth_month:1, phone:"", email:"" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [created, setCreated] = useState(null);

  const upd = (k,v) => setForm(p => ({...p, [k]:v}));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError("");
    try {
      const r = await api.post("/admin/members", { ...form, birth_month: Number(form.birth_month) });
      setCreated(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to create");
    } finally {
      setSaving(false);
    }
  };

  if (created) return (
    <Layout>
      <div className="max-w-xl mx-auto px-6 py-16 fade-in">
        <div className="label-eyebrow mb-2" style={{ color: "var(--ab-primary)" }}>Member Created</div>
        <h1 className="font-display text-3xl font-black mb-3">Welcome, {created.first_name}.</h1>
        <p className="text-sm mb-6" style={{ color: "var(--ab-text-muted)" }}>Welcome email sent to {created.email}. Their account number is the phone number below.</p>
        <div className="surface p-5 font-mono">Account #: <b>{created.phone}</b></div>
        <div className="mt-6 flex gap-3">
          <button className="btn-primary" onClick={() => { setCreated(null); setForm({ first_name:"", last_name:"", birth_month:1, phone:"", email:"" }); }} data-testid="member-signup-another">Add Another</button>
          <button className="btn-secondary" onClick={() => nav("/pos/dashboard")} data-testid="member-signup-done">Done</button>
        </div>
      </div>
    </Layout>
  );

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-6 py-12">
        <button onClick={() => nav("/pos/dashboard")} className="label-eyebrow mb-6 inline-block" data-testid="member-signup-back">← Back</button>
        <div className="flex items-center gap-3 mb-6">
          <UserPlus size={24} style={{ color: "var(--ab-primary)" }} />
          <h1 className="font-display text-3xl font-black">Add AB Member</h1>
        </div>
        <form onSubmit={submit} className="surface p-6 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="label-eyebrow block mb-2">First Name</label>
              <input className="input-terminal" required value={form.first_name} onChange={(e) => upd("first_name", e.target.value)} data-testid="ms-first" /></div>
            <div><label className="label-eyebrow block mb-2">Last Name</label>
              <input className="input-terminal" required value={form.last_name} onChange={(e) => upd("last_name", e.target.value)} data-testid="ms-last" /></div>
            <div><label className="label-eyebrow block mb-2">Birth Month</label>
              <select className="input-terminal" value={form.birth_month} onChange={(e) => upd("birth_month", e.target.value)} data-testid="ms-month">
                {MONTHS.map((m, i) => <option key={m} value={i+1}>{m}</option>)}
              </select></div>
            <div><label className="label-eyebrow block mb-2">Phone (Account #)</label>
              <input className="input-terminal" required value={form.phone} onChange={(e) => upd("phone", e.target.value)} placeholder="5551234567" data-testid="ms-phone" /></div>
            <div className="sm:col-span-2"><label className="label-eyebrow block mb-2">Email</label>
              <input type="email" className="input-terminal" required value={form.email} onChange={(e) => upd("email", e.target.value)} data-testid="ms-email" /></div>
          </div>
          {error && <div className="text-sm" style={{ color: "var(--ab-danger)" }} data-testid="ms-error">{error}</div>}
          <button type="submit" disabled={saving} className="btn-primary inline-flex items-center gap-2" data-testid="ms-submit">
            {saving ? <Loader2 size={14} className="animate-spin" /> : <UserPlus size={14} />} Create Member
          </button>
        </form>
      </div>
    </Layout>
  );
}
